export default "__VITE_ASSET__D$Ndvj3s__"